import { Colors, Lightning } from "@lightningjs/sdk";
import { Badge } from "../Badge/Badge";
import { Theme, themeManager } from "../../configurations/Theme/ThemeManager";
import { TranslatableText } from "../TranslatableText/TranslatableText";

interface MediaCategoryTemplateSpec extends Lightning.Component.TemplateSpec {
    label: string;
    Category: {
        Label: typeof TranslatableText;
        Badge: typeof Badge;
    };
    Name: object;
}

export class MediaCategory
    extends Lightning.Component<MediaCategoryTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<MediaCategoryTemplateSpec>
{
    readonly Category = this.getByRef("Category")!;
    readonly Label = this.Category.getByRef("Label")!;
    private _themeCallback!: (customTheme: Theme | undefined) => void;

    static override _template(): Lightning.Component.Template<MediaCategoryTemplateSpec> {
        return {
            h: 40,
            Category: {
                flex: { direction: "row", alignItems: "center" },
                Label: {
                    flexItem: { marginRight: 22 },
                    type: TranslatableText,
                    text: {
                        text: "",
                        fontSize: 32,
                        textColor: Colors("text").alpha(0.6).get(),
                        fontFace: "SemiBold"
                    }
                }
            }
        };
    }

    override _init() {
        this._themeCallback = this._onThemeChange.bind(this);
        themeManager.subscribe(this._themeCallback);
    }

    private _onThemeChange(customTheme: Theme | undefined): void {
        this.Label.patch({ text: { textColor: customTheme?.title ?? Colors("text").alpha(0.6).get() } });
    }

    override _detach() {
        themeManager.unsubscribe(this._themeCallback);
    }

    set label(value: string) {
        this.Label.patch({
            backupValue: value,
            key: `category.${value}`
        });
    }
}
